// extracted by mini-css-extract-plugin
module.exports = {"default":"_type_default__ZR_4j","right":"_type_right__37jKF","left":"_type_left__nSWIF","top":"_type_top__3dBOk","bottom":"_type_bottom__38DL8"};